import {
    StyledHeaderGroup,
    StyledSectionDescription,
    StyledSectionTitle,
} from 'pages/Home/homeStyle.css'

import {
    StyledChatWrapper,
    StyledContainer,
    StyledHorizontalDivider,
    StyledMainWrapper,
} from 'routes/ChatRouteLayout'
import { StyledAppContainer } from 'components/Layout/LayoutStyle'
import { StyledTableWrapper } from 'pages/Billing/panels/Transactions'

import LogsTable from 'pages/Home/components/LogsTable'
import { ButtonTertiary } from 'components/Button/Button'
import { useState } from 'react'
import { StyledClose, StyledFilterIcon } from 'pages/Subnets/panels/SubnetApiServie'
import { t } from 'i18next'

const Logs = () => {
    const [showFilters, setShowFilters] = useState(false)

    return (
        <StyledAppContainer>
            <StyledContainer>
                <StyledMainWrapper>
                    <StyledChatWrapper>
                        <StyledHeaderGroup className='header_group'>
                            <div>
                                <StyledSectionTitle>Logs</StyledSectionTitle>
                                <StyledSectionDescription>
                                    View detailed logs of all API calls made to the subnets.
                                </StyledSectionDescription>
                            </div>

                            <div>
                                <ButtonTertiary onClick={() => setShowFilters(!showFilters)}>
                                    {!showFilters ? (
                                        <StyledFilterIcon size={26} />
                                    ) : (
                                        <StyledClose size={26} />
                                    )}
                                    {t('filters')}
                                </ButtonTertiary>
                            </div>
                        </StyledHeaderGroup>

                        <StyledHorizontalDivider />

                        <StyledTableWrapper>
                            <LogsTable showFilters={showFilters} />
                        </StyledTableWrapper>
                    </StyledChatWrapper>
                </StyledMainWrapper>
            </StyledContainer>
        </StyledAppContainer>
    )
}

export default Logs
